module.exports = __webpack_public_path__ + "img/the_museum_of_the_holy_house_of_mercy_of_macau.88b5d277.jpg";